import { hashKey, useQuery } from '@tanstack/react-query';

import { CustomsNotificationResult, PullCustomsNotificationsSchema } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useCustomsNotifications = (criteria) =>
  useQuery({
    queryKey: ['admin-customs-notifications', hashKey(criteria)],
    queryFn: async (): Promise<CustomsNotificationResult> => {
      const validatedCriteria = PullCustomsNotificationsSchema.parse(criteria);
      try {
        const result = await apiClient.customsNotifications.pullCustomsNotifications.mutation({ body: validatedCriteria });
        return result.body;
      } catch (error) {
        showErrorToast(error, 'Error getting notifications!');
      }
    },
  });
